import { useEffect, useState } from 'react';
import { store } from 'redux-rest-reducer';
import { useDispatch, useSelector } from 'react-redux';
import { useAcLedMappingPost } from 'actions/ac-led-mapping';
import { showNotification } from 'actions/notification';
import { closeModal } from 'actions/modal';
import { get as getConfig } from 'actions/configs';
import {
  AC_LED_MAPPING_EVENTS,
  AC_LED_MAPPING_REJECTION_REASONS_KEY,
} from 'constants/ac-led-mapping';

const useLogic = ({ prospectID, onClose }) => {
  const [reason, setReason] = useState('');
  const configsStore = useSelector(({ configs }) => configs);
  const dispatch = useDispatch();

  const options =
    store.get(configsStore, AC_LED_MAPPING_REJECTION_REASONS_KEY)?.data ?? [];

  useEffect(() => {
    dispatch(getConfig?.(AC_LED_MAPPING_REJECTION_REASONS_KEY));
  }, [dispatch]);

  const handleChange = value => setReason(value);

  const onAcLedMappingFeedbackComplete = errorMessage => {
    if (errorMessage) {
      dispatch(
        showNotification({
          text: 'Failed to submit feedback',
          duration: 10,
          showCloseIcon: true,
        }),
      );
    } else {
      dispatch(closeModal?.());
      onClose?.();
    }
  };

  const { post: mappingResultFeedbackPost, isProcessing } = useAcLedMappingPost({
    onComplete: onAcLedMappingFeedbackComplete,
  });

  const handleSubmit = () => {
    const data = {
      prospect_id: prospectID,
      event_name: AC_LED_MAPPING_EVENTS.REJECT_RECOMMENDED_TEACHERS_REASON_FILL,
      event_payload: {
        reason,
      },
    };
    mappingResultFeedbackPost?.(data);
  };

  const submitDisabled = !reason || isProcessing;
  const rejectionReasonOptions = Array.isArray(options)
    ? options?.map(option => ({ ...option, id: option?.value }))
    : [];

  return {
    handleChange,
    reason,
    options: rejectionReasonOptions,
    handleSubmit,
    submitDisabled,
    isProcessing,
  };
};

export default useLogic;
